import { render, staticRenderFns } from "./Ok.vue?vue&type=template&id=42da1b03&scoped=true"
import script from "./Ok.vue?vue&type=script&lang=js"
export * from "./Ok.vue?vue&type=script&lang=js"
import style0 from "./Ok.vue?vue&type=style&index=0&id=42da1b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da1b03",
  null
  
)

export default component.exports